import { render, staticRenderFns } from "./XolasTable.vue?vue&type=template&id=5f1e6b36&scoped=true"
import script from "./XolasTable.vue?vue&type=script&lang=js"
export * from "./XolasTable.vue?vue&type=script&lang=js"
import style0 from "./XolasTable.vue?vue&type=style&index=0&id=5f1e6b36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1e6b36",
  null
  
)

export default component.exports